function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Heading } from '../../atoms';
import ReactConfigContext from '../../ReactConfigContext';
export default function ColumnInfoBlock(param) {
    var id = param.id, title = param.title, entries = param.entries, _param_sortDirection = param.sortDirection, sortDirection = _param_sortDirection === void 0 ? 'horizontal' : _param_sortDirection, className = param.className;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    return /*#__PURE__*/ React.createElement("div", {
        id: id,
        className: className
    }, !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title), /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: "my-3 border-t border-t-fg-base/25"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-3 grid-flow-row-dense auto-rows-max grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
    }, entries.map(function(entry, index) {
        var group3split = entries.length / 3;
        var group2split = entries.length / 2;
        var mdColIndex = group3split ? Math.floor(index / group3split) + 1 : 1;
        var smColIndex = group2split ? Math.floor(index / group2split) + 1 : 1;
        var style = _object_spread_props(_object_spread({}, entry.style), {
            '--col-start-md': mdColIndex,
            '--col-start-sm': smColIndex
        });
        var entryCx = twMerge(sortDirection === 'vertical' && 'sm:col-start-[var(--col-start-sm)] md:col-start-[var(--col-start-md)]', entry.className);
        var children = /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
            variant: "md"
        }, entry.title), !!entry.subtitle && /*#__PURE__*/ React.createElement(Body, {
            className: "font-semibold"
        }, entry.subtitle));
        if (entry.action) {
            return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread({
                key: entry.title,
                className: entryCx,
                style: style
            }, entry.action), children);
        }
        return /*#__PURE__*/ React.createElement("div", {
            key: entry.title,
            className: entryCx,
            style: style
        }, children);
    })));
}

//# sourceMappingURL=ColumnInfoBlock.js.map